import React from "react";

export type TQwenIconProps = React.SVGAttributes<SVGElement>;

export function QwenIcon({ ...rest }: TQwenIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...rest}>
      <g clipPath="url(#clip0_5714_9)">
      <path d="M24 15.0472L20.832 9.48059L22.504 6.63542C22.6376 6.39791 22.6376 6.10432 22.504 5.86681L20.832 3.02165C20.7473 2.86826 20.586 2.77259 20.4084 2.77259H14.2321L12.8079 0.249055C12.7231 0.0956636 12.5618 0 12.3842 0H9.08586C8.90823 0 8.7469 0.0956636 8.66216 0.249055L5.49421 5.81403H2.19589C2.01827 5.81403 1.85693 5.9097 1.77219 6.06309L0.100221 8.90825C-0.0334069 9.14576 -0.0334069 9.43935 0.100221 9.67686L2.92921 14.841L1.50494 17.3646C1.37131 17.6021 1.37131 17.8957 1.50494 18.1332L3.17691 20.9784C3.26165 21.1317 3.42298 21.2274 3.60061 21.2274H9.77681L11.2011 23.7509C11.2858 23.9043 11.4472 24 11.6248 24H14.9231C15.1007 24 15.2621 23.9043 15.3468 23.7509L18.5148 18.186H21.3437C21.5214 18.186 21.6827 18.0903 21.7674 17.9369L23.4394 15.0917C23.573 14.8542 23.573 14.5606 23.4394 14.3231L24 15.0472Z" fill="url(#paint0_radial_5714_9)"/>
      <path d="M14.9231 24.0005H11.6248L9.77683 20.9788H3.60063L5.49423 17.9572H8.66218L1.77222 6.23013H5.49423L9.08588 0.249512L10.7579 3.27116L9.08588 6.23013H21.8424L20.1705 9.0753L23.3384 14.6403H20.1705L18.5148 11.6813L11.9996 24.0005H14.9231Z" fill="white"/>
      <path d="M16.3473 10.2773H7.91895L11.9995 17.2509L16.3473 10.2773Z" fill="url(#paint1_radial_5714_9)"/>
      </g>
      <defs>
      <radialGradient id="paint0_radial_5714_9" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(11.8073 13.604) rotate(90) scale(16.4937 16.296)">
      <stop stopColor="#665CEE"/>
      <stop offset="1" stopColor="#332E91"/>
      </radialGradient>
      <radialGradient id="paint1_radial_5714_9" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(11.8072 13.6041) rotate(90) scale(16.4937 16.296)">
      <stop stopColor="#665CEE"/>
      <stop offset="1" stopColor="#332E91"/>
      </radialGradient>
      <clipPath id="clip0_5714_9">
      <rect width="24" height="24" fill="white"/>
      </clipPath>
      </defs>
    </svg>
  );
}
